import { axiosLasta } from 'config';
import { buildResponseUnauthorizedErrorHandler } from 'utils/axiosHelper/axiosErrorHandlerHelper.js';

export const fetchYardCheck = async ({ locationId }) => {
    const url = `/yard-check/location/${locationId}`;

    const response = await axiosLasta(url, {
        handleResponseError: buildResponseUnauthorizedErrorHandler("You don't have permission to access Inventory Check List."),
    });
    return response?.data ?? [];
};

export const createYardCheck = async (payload) => {
    const response = await axiosLasta.post(`/yard-check`, payload);
    const { data } = response;
    return data;
};

export const editYardCheck = async (payload, id) => {
    const response = await axiosLasta.put(`/yard-check/${id}`, payload);
    const { data } = response;
    return data;
};

export const removeYardCheck = async (id) => {
    const response = await axiosLasta.delete(`/yard-check/${id}`);
    const { data } = response;
    return data;
};

export const fetchYardCheckItemsByYardCheckId = async (id) => {
    const response = await axiosLasta(`/yard-check/${id}/yard-check-items`);
    const { data } = response;
    return data;
};

export const addCheckedItem = async (payload) => {
    const response = await axiosLasta.post(`/yard-check-item`, payload);
    const { data } = response;
    return data;
};

export const removeCheckedItem = async (yardCheckItemId) => {
    const response = await axiosLasta.delete(`/yard-check-item/${yardCheckItemId}`);
    const { data } = response;
    return data;
};

export const editCheckedItem = async ({ yardCheckItemId, payload }) => {
    const response = await axiosLasta.put(`/yard-check-item/${yardCheckItemId}`, payload);
    const { data } = response;
    return data;
};

export const fetchYardCheckSummary = async (id) => {
    const response = await axiosLasta.get(`/yard-check/${id}/summary`);
    const { data } = response;
    return data;
};

export const submitYardCheckSummary = async (id, payload) => {
    const response = await axiosLasta.post(`/yard-check/${id}/inventory-synchronizations`, payload);
    const { data } = response;
    return data;
};

export const bulkAddFromInventory = async (payload) => {
    const response = await axiosLasta.post(`/yard-check-item/bulk-add-from-inventory`, payload);
    const { data } = response;
    return data;
};
